import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

    constructor() { }

    public exportAsExcelFile(json: any[], excelFileName: string, customstring: string[]): void {
        // ...Create a new workbook and add a new worksheet 
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        // ... Empty excel row
        XLSX.utils.sheet_add_aoa(worksheet, [[]], { origin: -1 });
        // ...iterating over array to write the string to worksheet
        for (var item of customstring)
            XLSX.utils.sheet_add_aoa(worksheet, [[item]], { origin: -1 });

        const workbook: XLSX.WorkBook = { Sheets: { 'InvoiceDiscrepancy': worksheet }, SheetNames: ['InvoiceDiscrepancy'] };

        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().toISOString().split('T')[0] + EXCEL_EXTENSION);
    }
    
}